
const state = {
    history: [],
    redoHistory: [],
}

const getters = {
    // getCompleted( state ) {
    //    return state.completed
    // },
}

const actions = {
    // {row,col,input}
    pushHistory({ commit }, payload) {
        // let current = JSON.stringify(state.history[state.history.length-1])
        // if (JSON.stringify(payload) !== current)
        commit('PUSH_HISTORY', payload)
    },

    clearRedoHistory({ commit }) {
        commit('CLEAR_REDO_HISTORY')
    },

    undoRedo({ commit, dispatch, rootGetters, state }, isRedo) {
        let current = state.history[state.history.length-1]
        let push = 'PUSH_REDO_HISTORY'
        let pop = 'POP_HISTORY'

        if (isRedo) {
            current = state.redoHistory[state.redoHistory.length-1]
            push = 'PUSH_HISTORY'
            pop = 'POP_REDO_HISTORY'
        }
        
        if (!isRedo && !state.history.length || 
            isRedo && !state.redoHistory.length
        ) {
            return
        }
        // {row,col,input}
        let payload = JSON.stringify(current)
        payload = JSON.parse(payload)

        let payloadB = JSON.stringify(payload)
        payloadB = JSON.parse(payloadB)
        payloadB.input = rootGetters['grid/getInputAtPosition'](payloadB.row, payloadB.col)

        payload.isUndo = true

        commit(push, payloadB)

        if (payload.isMark)
            dispatch('grid/setMarkAtPos', payload, { root: true })
        else
            dispatch('grid/setInputAtPos', payload, { root: true })

        commit(pop)
    },


    // setCompleted({ commit, rootState }) {
    //     let userInputs = JSON.stringify(rootState.grid.userInputs)
    //     let solution = JSON.stringify(rootState.grid.solution)
    //     let completed = (userInputs == solution)

    //     commit('SET_COMPLETED', completed)
    // },
}

const mutations = {
    PUSH_HISTORY(state, payload) {
        state.history.push(payload)
    },

    POP_HISTORY(state) {
        state.history.pop()
    },

    PUSH_REDO_HISTORY(state, payload) {
        state.redoHistory.push(payload)
    },

    POP_REDO_HISTORY(state) {
        state.redoHistory.pop()
    },

    CLEAR_REDO_HISTORY(state) {
        state.redoHistory = []
    }

}

export {
    state,
    getters,
    actions,
    mutations,
}